"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjector = exports.useProjectHook = exports.createProjectInjector = exports.ConfigToken = exports.CredentialsToken = void 0;
const ui_core_injector_1 = require("@desygner/ui-core-injector");
const project_service_1 = require("./services/project.service");
const project_facade_1 = require("./facades/project.facade");
exports.CredentialsToken = new ui_core_injector_1.InjectionToken('CredentialsToken');
exports.ConfigToken = new ui_core_injector_1.InjectionToken('ConfigToken');
const providers = [
    {
        provide: project_service_1.ProjectService,
        useClass: project_service_1.ProjectService,
        deps: [exports.ConfigToken, exports.CredentialsToken],
    },
    {
        provide: project_facade_1.ProjectDataFacade,
        useClass: project_facade_1.ProjectDataFacade,
        deps: [project_service_1.ProjectService],
    },
];
let injector;
function createProjectInjector(config) {
    var _a;
    injector = (0, ui_core_injector_1.makeInjector)([
        ...providers,
        {
            provide: exports.CredentialsToken,
            useValue: config.token,
        },
        {
            provide: exports.ConfigToken,
            useValue: {
                baseUrl: config.baseUrl,
                staticsUrl: config.staticsUrl,
                company: config.company,
                fetchTimeout: (_a = config.fetchTimeout) !== null && _a !== void 0 ? _a : 10000,
            },
        },
    ]);
    return injector;
}
exports.createProjectInjector = createProjectInjector;
function useProjectHook(token) {
    if (!injector)
        throw new Error('Project injector not initialized');
    return (0, ui_core_injector_1.useInjectorHook)(token, injector);
}
exports.useProjectHook = useProjectHook;
function useInjector(token) {
    const [value] = (0, ui_core_injector_1.useInjectorHook)(token, injector);
    return value;
}
exports.useInjector = useInjector;
//# sourceMappingURL=project-injector.js.map